import React from 'react';
import { ArrowLeft } from 'lucide-react';


const SubscriptionModal = ({
  isOpen, 
  onClose, 
  subscriptionPlans, 
  showSubscription, 
  setShowSubscription,
  subscribeProduct,
  // optional props for editing an existing subscription
  editSubscription,
  updateSubscriptionPlan
}) => {
  if (!isOpen) return null;
  
  return (
    <div className="min-h-full bg-gray-50">
      <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-6 rounded-b-3xl">
        <div className="flex items-center justify-between mb-2">
          <button
            onClick={onClose}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all"
            title="Back"
          >
            <ArrowLeft size={22} />
          </button>
        </div>
        <h1 className="text-2xl font-bold">Subscribe & Save</h1>
        <p className="text-blue-100">Choose a plan and save on every delivery</p>
      </div>

      <div className="p-4">
        {showSubscription && (
          <>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 mb-6 flex items-center">
              <span className="text-5xl mr-4">{showSubscription.image}</span>
              <div>
                <h3 className="font-bold text-gray-800">{showSubscription.name}</h3>
                <p className="text-sm text-gray-600">{showSubscription.description}</p>
                <p className="text-lg font-bold text-blue-600 mt-1">₹{showSubscription.price}/unit</p>
              </div>
            </div>

            <h3 className="font-semibold text-gray-800 mb-3">Choose a Plan</h3>
            <div className="space-y-3 mb-6">
              {subscriptionPlans.map(plan => {
                const dailyPrice = (showSubscription.price * (100 - plan.discount)) / 100;
                const totalPrice = plan.id === 'daily' ? dailyPrice * 30 : plan.id === 'alternate' ? dailyPrice * 15 : dailyPrice * 7;

                return (
                  <div
                    key={plan.id}
                    className="border-2 border-gray-200 rounded-xl p-4 hover:border-blue-400 transition-all cursor-pointer bg-white"
                  >
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h4 className="font-bold text-gray-800">{plan.name}</h4>
                        <p className="text-sm text-gray-500">{plan.duration} days</p>
                      </div>
                      <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-bold">
                        Save {plan.discount}%
                      </span>
                    </div>
                    <div className="flex justify-between items-end">
                      <div>
                        <p className="text-xs text-gray-500 line-through">₹{showSubscription.price}/day</p>
                        <p className="text-lg font-bold text-blue-600">₹{dailyPrice.toFixed(0)}/day</p>
                      </div>
                      <button
                        onClick={() => {
                          if (editSubscription && updateSubscriptionPlan) {
                            // update existing subscription plan
                            updateSubscriptionPlan(editSubscription.id, { planId: plan.id });
                            onClose();
                          } else {
                            subscribeProduct(showSubscription, plan);
                            onClose();
                          }
                        }}
                        className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600"
                      >
                        {(editSubscription && updateSubscriptionPlan) ? `Update Plan ₹${totalPrice.toFixed(0)}` : `Subscribe ₹${totalPrice.toFixed(0)}`}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
              <h4 className="font-semibold text-gray-800 mb-2">✨ Subscription Benefits</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Guaranteed daily/scheduled delivery</li>
                <li>• Skip or pause anytime</li>
                <li>• Priority customer support</li>
                <li>• Exclusive subscriber discounts</li>
                <li>• Free delivery always</li>
              </ul>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default SubscriptionModal;